import { render, staticRenderFns } from "./SectionRiskCodesCreate.vue?vue&type=template&id=74dc3d6a&scoped=true&"
import script from "./SectionRiskCodesCreate.vue?vue&type=script&lang=js&"
export * from "./SectionRiskCodesCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dc3d6a",
  null
  
)

export default component.exports